module.exports = __webpack_public_path__ + "static/media/healthArticle2.a4784d55.jpg";